
import React, { useRef } from "react";
import { Button } from "@/components/ui/button";
import { FileImage, Upload } from "lucide-react";
import { toast } from "sonner";

interface FileUploadButtonProps {
  onFileChange: (file: File) => void;
  disabled?: boolean;
}

const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  onFileChange,
  disabled = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Controleer toegestane bestandstypen
    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Alleen afbeeldingen (JPEG, PNG, GIF) en PDF bestanden worden ondersteund");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Bestand mag niet groter zijn dan 5MB");
      return;
    }

    onFileChange(file);
  };

  return (
    <>
      <input
        type="file"
        accept="image/jpeg,image/png,image/gif,application/pdf"
        className="hidden"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <Button
        variant="outline"
        size="sm"
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled}
      >
        <FileImage className="h-4 w-4 mr-1" />
        Bestand uploaden
      </Button>
    </>
  );
};

export default FileUploadButton;
